import React, {
    useState,
    useRef,
    useEffect
} from 'react';
import {
    getToken
} from "../../utils/auth";

const AvatarUpload = ({
                          initialAvatar,
                          onAvatarUploaded
                      }) => {
    const [avatar, setAvatar] = useState(initialAvatar || '');
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [imageError, setImageError] = useState(false);
    const fileInputRef = useRef();

    // Sync avatar preview with initialAvatar prop
    useEffect(() => {
        setAvatar(initialAvatar || '');
        setImageError(false); // Reset image error when avatar changes
    }, [initialAvatar]);

    const getAuthHeaders = () => {
        const token = getToken();
        return token ? {'Authorization': `Bearer ${token}`} : {};
    };

    // Auto-upload when file is chosen
    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        setError('');
        if (!file) return;
        setUploading(true);
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/topic/upload-image`, {
                method: 'POST',
                headers: {
                    ...getAuthHeaders(),
                },
                body: formData
            });

            // Check if response is JSON
            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                const text = await response.text();
                console.error('Server returned non-JSON response:', text);
                setError('Server error: ' + text);
                setUploading(false);
                return;
            }

            const result = await response.json();
            
            if (response.ok && result && result.url) {
                setAvatar(result.url);
                setError('');
                if (onAvatarUploaded) {
                    onAvatarUploaded(result.url);
                }
            } else {
                setError(result.message || 'Upload failed.');
            }
        } catch (err) {
            console.error('Upload error:', err);
            setError('Upload error: ' + err.message);
        }
        setUploading(false);
    };

    // Handle image load error
    const handleImageError = () => {
        setImageError(true);
        setError('Image failed to load');
    };

    // Handle image load success
    const handleImageLoad = () => {
        setImageError(false);
        setError('');
    };

    return (
        <div className="avatar-upload-container">
            <div className="avatar-preview">
                <img
                    width={150}
                    src={avatar || "/images/tuviendenthanh/no_image_icon.png"}
                    alt="Avatar"
                    className="avatar-img"
                    onError={handleImageError}
                    onLoad={handleImageLoad}
                    style={{
                        border: imageError ? '2px solid red' : 'none',
                        opacity: uploading ? 0.5 : 1
                    }}
                />
                {imageError && (
                    <div style={{color: 'red', fontSize: '12px', marginTop: '5px'}}>
                        Failed to load image: {avatar}
                    </div>
                )}
            </div>
            <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                style={{display: "none"}}
                onChange={handleFileChange}
            />
            <button
                type="button"
                className={`btn btn-primary avatar-upload-btn${uploading ? ' disabled' : ''}`}
                onClick={() => fileInputRef.current.click()}
                disabled={uploading}
            >
                {uploading ? "Đang tải lên..." : "Chọn hình ảnh"}
            </button>
            {error && <div className="avatar-upload-error">{error}</div>}
        </div>
    );
};

export default AvatarUpload;
